<template>
    <div class="partner" v-loading="showLoading">
        <el-form ref="ruleFormRef" style="max-width: 600px" :model="ruleForm" :rules="rules" label-width="auto">
            <el-form-item label="所属类目" prop="parentCategoryName">
                <!-- 使用 @mousedown 事件替代 @click 事件 -->
                <el-select v-model="ruleForm.parentCategoryName" placeholder="请选择所属类目" disabled>
                </el-select>
            </el-form-item>
            <el-form-item label="类目名称" prop="categoryName">
                <el-input v-model="ruleForm.categoryName" placeholder="请填写类目名称" disabled />
            </el-form-item>
            <!-- 标题图片 -->
            <el-form-item label="类目图标" prop="iconLink" v-if="wangyiDataType == 'child'">
                <div class="upload-wrapper">
                    <el-upload class="avatar-uploader" action="/shop/api/v1/category/saveCategoryImage"
                        :headers="header" name="imageFile" :show-file-list="false" :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                        <template #default>
                            <div v-if="imageUrl" class="el-upload-list__item is-ready image-container">
                                <img :src="imageUrl" fit="cover" class="el-upload-list__item-thumbnail" />
                                <div class="image-actions">
                                    <el-icon class="action-icon" @click.stop="viewImage">
                                        <ZoomIn />
                                    </el-icon>
                                    <el-icon class="action-icon" @click.stop="removeImage">
                                        <Delete />
                                    </el-icon>
                                </div>
                            </div>
                            <el-icon v-else class="avatar-uploader-icon">
                                <Plus />
                            </el-icon>
                        </template>
                    </el-upload>
                    <div class="recommend-tip">推荐：图片尺寸 宽300px、高300px,图片体积小于1M。</div>
                </div>
            </el-form-item>
            <el-form-item label="是否启用" prop="state">
                <el-select v-model="ruleForm.state" placeholder="请选择是否启用">
                    <el-option label="启用" value="1" />
                    <el-option label="未启用" value="2" />
                </el-select>
            </el-form-item>
            <el-form-item label="映射平台类目" prop="platformCategoryName" v-if="wangyiDataType == 'child'">
                <!-- 使用 @mousedown 事件替代 @click 事件 -->
                <el-select ref="selectRef" @focus="closeSelect" v-model="ruleForm.platformCategoryName"
                    placeholder="请选择映射类目" @mousedown="openDialog">
                </el-select>
            </el-form-item>

            <el-form-item label="排序" prop="sort">
                <el-input v-model="ruleForm.sort" placeholder="请填写排序" />
                <div style="color:#909399;">提示：大到小排序 默认1000</div>
            </el-form-item>
            <el-form-item label="毛利率" prop="grossMargin">
                <!-- 添加 oninput 事件，限制只能输入数字 -->
                <el-input v-model="ruleForm.grossMargin" placeholder="请填写毛利率"
                    oninput="value=value.replace(/[^\d]/g,'')" />
                <div style="color:#909399;">提示：请填写整数</div>
            </el-form-item>

            <el-form-item>
                <!-- 绑定 loading 状态 -->
                <el-button type="primary" @click="submitForm(ruleFormRef)" :loading="submitLoading"
                    :disabled="submitLoading">
                    提交
                </el-button>
            </el-form-item>
        </el-form>
        <!-- 所属映射平台类目弹窗 -->
        <div>
            <s3-layer v-model="visible" title="映射平台类目" :shadeClose="true" :area="['500px', '80vh']">
        <!-- 修改 el-tree 配置 -->
        <el-tree 
            :data="texture" 
            :props="defaultProps" 
            accordion 
            @node-click="handleNodeClick"
            @node-expand="handleNodeExpand"
        />
    </s3-layer>
        </div>
        <el-dialog v-model="dialogVisible" title="查看大图">
            <img :src="imageUrl" style="width: 100%">
        </el-dialog>
    </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import { Plus, ZoomIn, Delete } from '@element-plus/icons-vue';
import { useRouter } from 'vue-router'; // 引入路由
import {
    editWangyiPlatformData, platformInfo, getWangyiPlatformDetail
} from "../../../../request/api";
import qs from 'qs';
const router = useRouter(); // 获取路由实例
const header = ref({
    timeout: 10000,
    'accessToken': sessionStorage.getItem('token')
})
const ruleFormRef = ref();
const brandImage = ref('');
const selectIt = ref();
const initialImageUrl = ref('');
const wangyiDataType = ref(sessionStorage.getItem('wangyiDataType'));
const showLoading = ref(true); //加载loading

// 添加提交加载状态
const submitLoading = ref(false);
// 使用 reactive 创建响应式对象
const ruleForm = reactive({
    parentCategoryName: '', // 父级类目名称
    categoryName: '', // 类目名称
    iconLink: '', // 添加这个字段用于存储图片路径
    categoryId: '', // 类目ID
    state: '',  //是否启用 1启用 2未启用
    sort: '',  //排序
    grossMargin: '',  //毛利率
    platformCategoryId: '', //映射平台类目ID
    platformCategoryName: ''
})
const closeSelect = () => {
    selectIt.value.blur();
}
// 弹窗组织列表树形
const texture = ref([]);
const defaultProps = {
    label: 'platformCategoryName',
    children: 'platformCategory'
}
onMounted(() => {
    dataInfo().then(() => {
        platformDetail();
    });
})

const dataInfo = () => {
    return new Promise((resolve) => {
        platformInfo().then((res) => {
            if (res.data.code == 0) {
                texture.value = [res.data.data.platformCategoryInfo];
            }
            resolve();
        })
    });
}

// 获取类目详情
const platformDetail = async () => {
    try {
        const params = {
            categoryId: sessionStorage.getItem('categoryId'),
        }
        getWangyiPlatformDetail(qs.stringify(params)).then((res) => {
            if (res.data.code === 0) {
                const data = res.data.data.categoryInfo;
                // 强制转为字符串，确保和选项value类型一致
                data.state = String(data.state);
                imageUrl.value = res.data.data.categoryInfo.iconLink;
                initialImageUrl.value = res.data.data.categoryInfo.iconLink;
                ruleForm.parentCategoryName = res.data.data.categoryInfo.parentcategoryName;
                ruleForm.iconLink = res.data.data.categoryInfo.iconLink; 
                Object.assign(ruleForm, res.data.data.categoryInfo);

                // 递归查找匹配的 platformCategoryName
                const findPlatformCategoryName = (nodes, targetId) => {
                    for (const node of nodes) {
                        if (node.platformCategoryId === targetId) {
                            return node.platformCategoryName;
                        }
                        if (node.platformCategory) {
                            const name = findPlatformCategoryName(node.platformCategory, targetId);
                            if (name) {
                                return name;
                            }
                        }
                    }
                    return null;
                };
                // 调用查找函数
                const platformCategoryName = findPlatformCategoryName(texture.value, ruleForm.platformCategoryId);
                if (platformCategoryName) {
                    ruleForm.platformCategoryName = platformCategoryName;
                }
                showLoading.value = false;
            } else {
                ElMessage.error(res.data.msg || '获取网易类目详情失败');
            }
        })
    } catch (error) {
        console.error('获取网易类目详情出错:', error);
        ElMessage.error('获取网易类目详情出错');
    }
};
// 定义 el-select 的 ref
const selectRef = ref(null);

const openDialog = (event) => {
    // 阻止默认的下拉框展开行为
    event.preventDefault();
    visible.value = true;
    // 手动关闭下拉框
    if (selectRef.value) {
        selectRef.value.hideDropdown();
    }
}

// 处理节点点击事件
const handleNodeClick = (data, node) => {
    if (node.isLeaf) {
        // 只有叶子节点（即 platformCategory 里的数据）才调用 dendrogram 方法
        dendrogram(data);
    } else {
        // 非叶子节点点击时展开或折叠
        node.expanded = !node.expanded;
    }
};

// 处理节点展开事件
const handleNodeExpand = (data, node) => {
    // 可以在这里添加展开节点时的额外逻辑
};

// 弹窗树形选择
const dendrogram = (node) => {
    ruleForm.platformCategoryName = node.platformCategoryName;
    ruleForm.platformCategoryId = node.platformCategoryId;
    visible.value = false;
}
const rules = {
    categoryName: [
        { required: true, message: '请填写类目名称', trigger: 'blur' },
    ],

    parentCategoryName: [
        {
            required: true,
            message: '请选择所属类目',
            trigger: 'change',
        },
    ],
    platformCategoryName: [
        {
            required: true,
            message: '请选择映射平台类目',
            trigger: 'change',
        },
    ],
    iconLink: [
        { required: true, message: "请上传类目图标", trigger: "submit" },
    ],
    state: [
        {
            required: true,
            message: '请选择是否启用',
            trigger: 'change',
        },
    ],
}
// 提交表单
const submitForm = async (formEl) => {
    console.log(ruleForm.iconLink);
    
    if (!formEl || showLoading.value) return; // 数据加载中不允许提交

    // 如果正在提交中，直接返回
    if (submitLoading.value) return;

    try {
        submitLoading.value = true; // 开始加载

        // 先进行表单验证
        await formEl.validate();

        // 打印 iconLink 值，确认是否正确
        console.log('提交时 iconLink 的值:', ruleForm.iconLink); 

        // 检查图片是否被修改
        if (imageUrl.value === initialImageUrl.value) {
            ruleForm.iconLink = '';
        }

        // 准备请求参数
        const params = {
            categoryName: ruleForm.categoryName, //类目名称  1
            categoryId: sessionStorage.getItem('categoryId'), //类目ID  1
            state: ruleForm.state,  //登录权限
            iconLink: ruleForm.iconLink,  //类目图标
            parentCategoryName: ruleForm.parentCategoryName, //上级类目名称
            grossMargin: ruleForm.grossMargin,  //毛利率
            sort: ruleForm.sort,  //排序
            platformCategoryId:ruleForm.platformCategoryId
        };

        // 使用 await 等待 API 调用完成
        const res = await editWangyiPlatformData(params);

        if (res.data.code === 0) {
            ElMessage.success('编辑成功');
            setTimeout(() => {
                router.push('/wangyi/platform');
            }, 1000);
        } else {
            throw new Error(res.data.msg || '编辑失败');
        }
    } catch (error) {
        console.error('编辑出错:', error);
        // 如果是表单验证错误，Element 会自动显示错误信息
        if (error.message !== '表单验证失败') {
            ElMessage.error(error.msg || '编辑失败');
        }
    } finally {
        submitLoading.value = false; // 无论成功或失败，结束加载
    }
};


const imageUrl = ref('');
const dialogVisible = ref(false);
const visible = ref(false);

const handleAvatarSuccess = (response, uploadFile) => {
    imageUrl.value = URL.createObjectURL(uploadFile.raw);
    brandImage.value = response.data.imagePath;
    ruleForm.iconLink = response.data.imagePath; // 设置iconLink字段的值
};

const beforeAvatarUpload = (rawFile) => {
    // 允许的图片格式
    const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/bmp'];
    const isImage = ALLOWED_TYPES.includes(rawFile.type);
    const isLt1M = rawFile.size / 1024 / 1024 < 1;

    if (!isImage) {
        ElMessage.error('只能上传 JPG/PNG/GIF/WEBP/BMP 格式的图片!');
        return false;
    }
    if (!isLt1M) {
        ElMessage.error('上传图片大小不能超过 1MB!');
        return false;
    }
    return true;
};

const viewImage = () => {
    dialogVisible.value = true;
};

const removeImage = () => {
    imageUrl.value = '';
    brandImage.value = '';
    ruleForm.iconLink = '';
};
</script>

<style lang="scss" scoped>
.partner {
    height: calc(100vh - 170px);
    background-color: #FFFFFF;
    width: 95%;
    padding: 20px;
    overflow: auto;
    box-shadow: var(--el-box-shadow-light);
    border-radius: 5px;
    margin: 15px auto;
}

.avatar-uploader .avatar {
    width: 110px;
    height: 110px;
    display: block;
}

.upload-wrapper {
    display: flex;
    align-items: flex-end;
    /* 使子元素底部对齐 */
    gap: 10px;
    /* 设置元素之间的间距 */
}

.recommend-tip {
    color: #cccccc;
}

/* 新增的图片容器样式 */
.image-container {
    position: relative;

    &:hover .image-actions {
        opacity: 1;
    }
}

.image-actions {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    opacity: 0;
    transition: opacity 0.3s;
}

.action-icon {
    color: white;
    font-size: 24px;
    cursor: pointer;

    &:hover {
        color: var(--el-color-primary);
    }
}
</style>

<style>
.avatar-uploader .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
}

.el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 110px;
    height: 110px;
    text-align: center;
}

.avatar-uploader .el-upload-list__item {
    width: 110px;
    height: 110px;
}

.el-upload-list__item-thumbnail {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.el-form-item__label-wrap .el-form-item__label {
    font-weight: bold;
}

.el-upload-list__item {
    margin-bottom: 0;
}

.hint_box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    .hint_title {
        width: 120px;
        text-align: right;
        color: #909399;
        font-weight: bold;
    }

    .hint_text {
        color: #909399;
        font-size: 14px;
    }
}

.el-input__inner {
    height: 38px !important;
    line-height: 38px !important;
}
</style>